import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

type ToastState = { message: string; error?: boolean } | null;

const ToastCtx = createContext<{
  toast: (message: string, error?: boolean) => void;
} | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [t, setT] = useState<ToastState>(null);
  const toast = useCallback((message: string, error = false) => {
    setT({ message, error });
    window.setTimeout(() => setT(null), 3200);
  }, []);
  const value = useMemo(() => ({ toast }), [toast]);
  return (
    <ToastCtx.Provider value={value}>
      {children}
      {t && (
        <div
          className={`fixed bottom-6 right-6 z-[60] px-4 py-2 rounded panel-border text-body-sm shadow-lg ${
            t.error ? "text-error border-error/40" : "bg-surface-container-high"
          }`}
          role="status"
        >
          {t.message}
        </div>
      )}
    </ToastCtx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error("useToast outside ToastProvider");
  return ctx;
}
